import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Editing,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber, GetFormatedDateWithTime, loadLookupFromDataSource } from '../../../../../common/Utils'
import { LotSublotHeaderLayout, SearchLayout, SublotByConsigneeHeaderLayout } from '../Layout';
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import { alert } from 'devextreme/ui/dialog';
import { ItemTypes } from '../../../../../enum/Enum';
import { MESSAGES } from '../../../../../common/Messages';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const SublotByConsignee = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [selectedRows, setSelectedRows] = useState(null);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "0BBEBD75-ADAC-4340-B39E-2F150FDFA346";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        SublotRConsignee: props.params?.ConsigneeId || null,
        Name: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);



    const handelOkClick = () => {
        if (selectedRows && selectedRows.length > 0) {
            props.onSublotByConsigneeSelect(selectedRows);

        }
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let filters = { ...formFields };
        filters.Name = null;
        loadData(filters);
    }

    const handleReset = (e) => {
        e.event.stopPropagation();
        loadData(initialFormFields);
        setformFields(initialFormFields);
    }

    useEffect(() => {
        if(props.params.ConsigneeId){
        let filters = { ...formFields };
        filters.Name = null;
        loadData(filters);
        }
    }, [props.params]);

    const loadData = (fields) => {
        const filters = FillFilters(fields);
        let datasource = loadDatasource();
        datasource.filter(filters);
        setResultData(datasource);
    }
    const loadDatasource = () => {
        let store = createStore({
            key: 'subLotRowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WM.GetSubLots}`,
            sort: [{ selector: "lotCode", desc: false }, { selector: "subLotCode", desc: false }],
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const handleFormLoad = useCallback(() => {
    }, []);

    const handleFieldChange = useCallback((name, value) => {

    }, []);


    const [resultData, setResultData] = useState(null);


    const handleValueChanged = (e) => {
        console.log(e)
    }
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData) {
            setSelectedRows(selectedRowsData);
        }
    };
    const handleSelectedItemChange = (name, e) => {
        if(name === "SublotRConsignee"){
            if(e.name){
                setformFields({ ...formFields, ['Name']:e.name });
            }
            else if (e.selectedItem?.name){
                setformFields({ ...formFields, ['Name']:e.selectedItem.name });
            }
        }
    }
    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <div id="accordion" >
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={(itemProps) => (
                                <FormField
                                    currrentUser={currentUser}
                                    layoutId='E2252C07-88B4-47F9-AAE8-2018F60A47DF'
                                    layoutName='WMSubLotDataEntryHeaderForm'
                                    defaultFormSchema={SublotByConsigneeHeaderLayout}
                                    formFields={formFields}
                                    setformFields={setformFields}
                                    handleFieldValueChange={handleFieldChange}
                                    handleSelectedItemChange={handleSelectedItemChange}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={formRefs}
                                    onFormLoad={handleFormLoad}
                                    noSpacingBeforeFirstRow={true}
                                />
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                        <DataGrid

                            onExporting={(e) => {
                                if (window.handleDevExtremeDataGridExport) {
                                    window.handleDevExtremeDataGridExport(e);
                                }
                            }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={resultData}
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={"GridHeightAccordianOpen-tabs-single-row-popup"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column dataField="subLotRowid" caption="Rowid" dataType="string" visible={false} />
                            <Column dataField="subLotCode" caption="SubLot" dataType="string" />
                            <Column dataField="itemCode" caption="Item" dataType="string" />
                            <Column dataField="lotCode" caption="Lot" dataType="string" />
                            <Column dataField="lotDescription1" caption="Lot Description" dataType="string" />
                            <Column dataField="itemDescription1" caption="Item Description" dataType="string" />
                            <Column dataField="subLotDescription1" caption="Sublot Description" dataType="string" />
                            <Column dataField="subLotAvailable" caption="Available" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} allowEditing={false}
                            />
                            <Column dataField="subLotSize1" caption="Size 1" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataField="subLotSize2" caption="Size 2" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataField="subLotNetAvailable" caption="Net Available" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataField="subLotOnHand" caption="On Hand" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataField="ConsigneeIdentityId" caption="Consignee ID" dataType="string" />
                            <Column dataField="ConsigneeName" caption="Consignee Name" dataType="string" />
                            <Column visible={false} dataField="subLotInOrdered" caption="Subl In Ordered" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="subLotOutOrdered" caption="Subl Out Ordered" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="subLotInReceiving" caption="Subl In Receiving" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="subLotOutShipped" caption="Subl Out Shipped" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="StorageBilledDateLast" caption="Storage Billed Date Last" dataType="datetime" />
                            <Column visible={false} dataField="StorageBilledDateNext" caption="Storage Billed Date Next" dataType="datetime" />
                            <Column visible={false} dataField="storageBillingsStartDate" caption="Storage Billing Start Date" dataType="datetime" />
                            <Column visible={false} dataField="StorageBillingEndDate" caption="Storage Billing End Date" dataType="datetime" />
                            <Column visible={false} dataField="alternateId" caption="Alternate Id" dataType="string" />
                            <Column visible={false} dataField="packagesPerShippingUnitQty" caption="Packages Per Shipping Unit Qty" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="ProjectionCode" caption="Projection Code" dataType="string" />
                            <Column visible={false} dataField="UnitsPerItemUnit" caption="Units Per Item Unit" dataType="string" />
                            <Column visible={false} dataField="unitsPerPackageUOM" caption="Unit Uom Default" dataType="string" />
                            <Column visible={false} dataField="SizeCode" caption="Size Code" dataType="string" />
                            <Column visible={false} dataField="UnitPrice" caption="Unit Price" dataType="string" />
                            <Column visible={false} dataField="unitsPerPackageQuantity" caption="Units Per Package Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="unitVolumeQuantity" caption="Unit Volume Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="UnitUomFlag" caption="Unit Uom Flag" dataType="string" />

                            <Column visible={false} dataField="WarrantyFlagShipmentItem" caption="Weight Basis Flag" dataType="string" />
                            <Column visible={false} dataField="NetWeightQuantityItem" caption="Item Net Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="GrossWeightQuantityItem" caption="Item Gross Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="dateAvailable" caption="Available Date" dataType="datetime" />
                            <Column visible={false} dataField="dateExpiration" caption="Expiration Date" dataType="datetime" />
                            <Column visible={false} dataField="subLotNetWeight" caption="Net Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="subLotGrossWeight" caption="Gross Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />


                            <Column visible={false} dataField="subLotUDFCode1" caption="Code 1" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode2" caption="Code 2" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode3" caption="Code 3" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode4" caption="Code 4" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode5" caption="Code 5" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode6" caption="Code 6" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode7" caption="Code 7" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode8" caption="Code 8" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode9" caption="Code 9" dataType="string" />
                            <Column visible={false} dataField="subLotUDFCode10" caption="Code 10" dataType="string" />
                            <Column visible={false} dataField="subLotUDFDate1" caption="Date 1" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate2" caption="Date 2" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate3" caption="Date 3" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate4" caption="Date 4" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate5" caption="Date 5" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate6" caption="Date 6" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate7" caption="Date 7" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate8" caption="Date 8" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate9" caption="Date 9" dataType="date" />
                            <Column visible={false} dataField="subLotUDFDate10" caption="Date 10" dataType="date" />
                            <Column visible={false} dataField="Quantity1Sublot" caption="Quantity 1" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity2Sublot" caption="Quantity 2" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity3Sublot" caption="Quantity 3" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity4Sublot" caption="Quantity 4" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity5Sublot" caption="Quantity 5" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity6Sublot" caption="Quantity 6" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity7Sublot" caption="Quantity 7" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity8Sublot" caption="Quantity 8" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity9Sublot" caption="Quantity 9" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity10Sublot" caption="Quantity 10" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Reference1Sublot" caption="Ref 1" dataType="string" />
                            <Column visible={false} dataField="Reference2Sublot" caption="Ref 2" dataType="string" />
                            <Column visible={false} dataField="Reference3Sublot" caption="Ref 3" dataType="string" />
                            <Column visible={false} dataField="Reference4Sublot" caption="Ref 4" dataType="string" />
                            <Column visible={false} dataField="Reference5Sublot" caption="Ref 5" dataType="string" />
                            <Column visible={false} dataField="Reference6Sublot" caption="Ref 6" dataType="string" />
                            <Column visible={false} dataField="Reference7Sublot" caption="Ref 7" dataType="string" />
                            <Column visible={false} dataField="Reference8Sublot" caption="Ref 8" dataType="string" />
                            <Column visible={false} dataField="Reference9Sublot" caption="Ref 9" dataType="string" />
                            <Column visible={false} dataField="Reference10Sublot" caption="Ref 10" dataType="string" />
                            <GridToolbar>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <Button
                                text="OK"
                                type="default"
                                disabled={!(selectedRows && selectedRows.length > 0)}
                                onClick={handelOkClick}
                                style={{ marginRight: '10px' }}
                            />
                            <Button
                                text="Cancel"
                                onClick={props.onManualItemLotScreenClose}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(SublotByConsignee);